<template>
    <div class="text-center">
        <input type="file" ref="inp_file" style="display: none" accept=".png,.jpg,.jpeg,.bmp" @change="fileSelected" />
        <v-icon v-if="valueCopy === ''" :size="size" @click="upload">mdi-image</v-icon>
        <v-img v-if="valueCopy != ''" :src="valueCopy" @click="upload" :height="img_height" contain style="cursor: pointer"></v-img>
        <v-text-field :value="value" label="url" prepend-icon="mdi-link" dense @change="urlChange" />
    </div>
</template>

<script>
import { getQiniuToken, uploadQiniu } from "../api/qiniu";
import { Log } from "../utils/debug";

export default {
    name: "ImgUpload",
    props: {
        value: {
            type: String,
            default: ""
        },
        size: {
            type: Number,
            default: 205
        },
        img_height: {
            type: String,
            default: "205px"
        }
    },
    data: () => ({
        valueCopy: ""
    }),
    mounted() {
        this.valueCopy = this.value;
    },
    methods: {
        upload: function() {
            this.$refs.inp_file.click();
        },
        fileSelected: function() {
            let files = this.$refs.inp_file.files;
            Log.debug(files);
            if (files.length === 0) return;

            getQiniuToken().then(res => {
                Log.debug(res);
                let token = res.data;
                let formData = new FormData();
                formData.append("file", files[0]);
                formData.append("token", token);
                uploadQiniu(formData)
                    .then(res => {
                        Log.debug(res);
                        this.valueCopy = "https://files.hexcode.cn/" + res.data.hash;
                        this.$emit("input", this.valueCopy);
                    })
                    .catch(res => {
                        Log.error(res);
                    });
            });
        },
        urlChange: function(url) {
            //console.log(url);
            this.valueCopy = url;
            this.$emit("input", this.valueCopy);
        }
    }
};
</script>

<style>
.v-autocomplete__content {
    z-index: 1501 !important;
}
</style>
